import { defineMessages } from 'react-intl';

export default defineMessages({
  travelRuleDetails: {
    id: 'sentinel.components.travelRuleDetailsPanel.travelRuleDetails',
    defaultMessage: 'Travel Rule Details',
  },
  originatorTitle: {
    id: 'sentinel.components.travelRuleDetailsPanel.originatorTitle',
    defaultMessage: 'Originator',
  },
  recipientTitle: {
    id: 'sentinel.components.travelRuleDetailsPanel.recipientTitle',
    defaultMessage: 'Recipient',
  },
  institutionName: {
    id: 'sentinel.components.travelRuleDetailsPanel.institutionName',
    defaultMessage: 'Institution Name',
  },
  institutionAccountNumber: {
    id: 'sentinel.components.travelRuleDetailsPanel.institutionAccountNumber',
    defaultMessage: 'Institution Account Number',
  },
  firstName: {
    id: 'sentinel.components.travelRuleDetailsPanel.firstName',
    defaultMessage: 'First Name',
  },
  lastName: {
    id: 'sentinel.components.travelRuleDetailsPanel.lastName',
    defaultMessage: 'Last Name',
  },
  address: {
    id: 'sentinel.components.travelRuleDetailsPanel.address',
    defaultMessage: 'Address',
  },
  entityName: {
    id: 'sentinel.components.travelRuleDetailsPanel.entityName',
    defaultMessage: 'Entity Name',
  },
});



// WEBPACK FOOTER //
// ./src/components/TravelRuleDetailsPanel/messages.js